<template>
  <div :id="id" class="chapter-section panel">
    <p class="panel-heading">{{ $t(`chapter3.title`) }}</p>

    <fieldset class="box">
      <b-field
        :label="$t(`chapter3.q0.text`)"
        :type="store.getFieldError('datenherkunft', 'datenQuellen') ? 'is-danger' : ''"
        :message="store.getFieldError('datenherkunft', 'datenQuellen')"
      >
        <div v-for="option in datenQuellenOptions" :key="option">
          <b-checkbox
            :required="true"
            v-model="study.datenherkunft.datenQuellen"
            :native-value="option"
            @change="onDatenQuellenChange"
          >
            {{ $t(`chapter3.q0.${option}`) }}
          </b-checkbox>

          <div
            class="box"
            v-if="option === 'vonExtern' && study.datenherkunft.datenQuellen.includes('vonExtern')"
          >
            <div v-for="option in datenQuelleExternOptions" :key="option">
              <b-checkbox
                v-model="study.datenherkunft.datenQuelleExtern"
                :native-value="option"
                @change="onDatenQuelleExternChange"
              >
                {{ $t(`chapter3.q0.extern-${option}`) }}
              </b-checkbox>
              <b-field
                v-if="
                  option === 'sonstige' &&
                  study.datenherkunft.datenQuelleExtern.includes('sonstige')
                "
                :type="
                  store.getFieldError('datenherkunft', 'datenQuelleExternSonstiges')
                    ? 'is-danger'
                    : ''
                "
                :message="store.getFieldError('datenherkunft', 'datenQuelleExternSonstiges')"
              >
                <b-input
                  :required="study.datenherkunft.datenQuelleExtern.includes('sonstige')"
                  v-model="study.datenherkunft.datenQuelleExternSonstiges"
                  :placeholder="$t(`chapter3.q0.extern-sonstigesPlaceholder`)"
                  @blur="save"
                />
              </b-field>
            </div>
          </div>

          <b-field
            v-if="option === 'sonstiges' && study.datenherkunft.datenQuellen.includes('sonstiges')"
          >
            <b-input
              v-model="study.datenherkunft.datenQuelleSonstiges"
              :placeholder="$t(`chapter3.q0.sonstigesPlaceholder`)"
              @blur="save"
            />
          </b-field>

          <fieldset v-if="showEigeneRecherche && option === 'eigeneRecherche'" class="box">
            <p>{{ $t(`chapter3.q0a.text`) }}</p>
            <div v-for="option in eigeneRechercheDokumenteOptions" :key="option">
              <b-checkbox
                v-model="study.datenherkunft.datenQuelleEigeneRechercheDokumente"
                :native-value="option"
                @change="onDatenQuelleEigeneRechercheDokumenteChange"
              >
                {{ $t(`chapter3.q0a.${option}`) }}
              </b-checkbox>
            </div>
            <b-field
              v-if="study.datenherkunft.datenQuelleEigeneRechercheDokumente.includes('sonstige')"
            >
              <b-input
                v-model="study.datenherkunft.datenQuelleEigeneRechercheDokumenteSonstige"
                :placeholder="$t(`chapter3.q0a.sonstigesPlaceholder`)"
                @blur="save"
              />
            </b-field>
            <br />
            <p>{{ $t(`chapter3.q0a1.text`) }}</p>
            <b-field>
              <div v-for="option in idatOptions" :key="option">
                <b-checkbox
                  v-model="study.datenherkunft.datenQuelleEigeneRechercheIdatBenoetigt"
                  :native-value="option"
                  @change="save"
                >
                  {{ $t(`chapter3.q0a1.${option}`) }}
                </b-checkbox>
              </div>
            </b-field>
          </fieldset>
        </div>
      </b-field>
    </fieldset>

    <fieldset class="box">
      <legend>{{ $t(`chapter3.q1.title`) }}</legend>
      <div v-for="option in quellSystemeOptions" :key="option">
        <b-checkbox
          v-model="study.datenherkunft.quellSysteme"
          :native-value="option"
          @change="onQuellsystemeChange"
        >
          {{ $t(`chapter3.q1.${option}`) }}
        </b-checkbox>
        <b-field
          v-if="option === 'sonstige' && study.datenherkunft.quellSysteme.includes('sonstige')"
        >
          <b-input
            v-model="study.datenherkunft.quellSystemeSonstige"
            :placeholder="$t(`chapter3.q1.sonstigePlaceholder`)"
            @blur="save"
          />
        </b-field>
      </div>
    </fieldset>

    <fieldset class="box">
      <legend>{{ $t(`chapter3.q2.title`) }}</legend>
      <b-field class="is-flex is-justify-content-flex-start">
        <b-switch v-model="showDatenWeitererKliniken" type="is-success">
          {{ $t(`chapter3.q2.textCheckbox`) }}
        </b-switch>
      </b-field>

      <div v-if="showDatenWeitererKliniken">
        <b-field
          :label="$t('chapter3.q2.text')"
          :type="store.getFieldError('datenherkunft', 'datenWeitererKliniken') ? 'is-danger' : ''"
          :message="store.getFieldError('datenherkunft', 'datenWeitererKliniken')"
        >
          <b-input
            :required="showDatenWeitererKliniken"
            v-model="study.datenherkunft.datenWeitererKliniken"
            @blur="save"
          />
        </b-field>
        <b-field class="is-flex is-justify-content-flex-start" style="margin-top: 1rem">
          <b-checkbox
            v-model="study.datenherkunft.einwilligungenWerdenEingeholt"
            type="is-success"
            @change="save"
          >
            {{ $t(`chapter3.q2.checkbox`) }}
          </b-checkbox>
        </b-field>
      </div>
    </fieldset>

    <fieldset class="box" v-if="study.datenherkunft.datenQuellen.includes('vonExtern')">
      <legend>{{ $t(`chapter3.q3.title`) }}</legend>
      <b-field :label="$t(`chapter3.q3.text`)">
        <div v-for="option in externeDatenOptions" :key="option">
          <b-checkbox
            v-model="study.datenherkunft.externeDaten"
            :native-value="option"
            @change="save"
          >
            {{ $t(`chapter3.q3.${option}`) }}
          </b-checkbox>
        </div>
      </b-field>
    </fieldset>

    <fieldset v-if="showVerwendeteGeraete" class="box">
      <legend>{{ $t(`chapter3.q4.title`) }}</legend>
      <b-field :label="$t(`chapter3.q4.text`)">
        <div v-for="option in geraeteOptions" :key="option">
          <b-checkbox
            v-model="study.datenherkunft.verwendeteGeraete.geraete"
            :native-value="option"
            @change="onVerwendeteGeraeteChange"
          >
            {{ $t(`chapter3.q4.${option}`) }}
          </b-checkbox>
          <b-field
            v-if="
              option === 'mobilgeraete' &&
              study.datenherkunft.verwendeteGeraete.geraete.includes('mobilgeraete')
            "
          >
            <template #label>
              <span style="margin-left: 1rem">{{ $t(`chapter3.q4a.title`) }}</span>
            </template>
            <div v-for="option in mobilgeraeteOptions" :key="option" style="margin-left: 1rem">
              <b-checkbox
                v-model="study.datenherkunft.verwendeteGeraete.mobilgeraeteHerkunft"
                :native-value="option"
                @change="save"
              >
                {{ $t(`chapter3.q4a.${option}`) }}
              </b-checkbox>
            </div>
          </b-field>
          <b-field
            v-if="
              option === 'sonstiges' &&
              study.datenherkunft.verwendeteGeraete.geraete.includes('sonstiges')
            "
          >
            <b-input
              v-model="study.datenherkunft.verwendeteGeraete.verwendeteGeraeteSonstiges"
              :placeholder="$t(`chapter3.q4.sonstigesPlaceholder`)"
              @blur="save"
            />
          </b-field>
        </div>
      </b-field>
    </fieldset>

    <fieldset class="box">
      <legend>{{ $t(`chapter3.q5.title`) }}</legend>
      <b-field class="is-flex is-justify-content-flex-start">
        <b-switch v-model="showExterneDaten" type="is-success">
          {{ $t(`chapter3.q5.textCheckbox`) }}
        </b-switch>
      </b-field>
      <b-field
        v-if="showExterneDaten"
        :label="$t(`chapter3.q5.placeholder`)"
        :type="
          store.getFieldError('datenherkunft', 'verwendungszweckVerknuepfungExtern')
            ? 'is-danger'
            : ''
        "
        :message="store.getFieldError('datenherkunft', 'verwendungszweckVerknuepfungExtern')"
      >
        <b-input
          type="textarea"
          :required="showExterneDaten"
          v-model="study.datenherkunft.verwendungszweckVerknuepfungExtern"
          @blur="save"
        />
      </b-field>
    </fieldset>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useStudyStore } from '@/stores/studyStore'
import { BCheckbox, BField, BInput, BSwitch } from 'buefy'

defineProps<{ id: string; modelValue?: object }>()

const store = useStudyStore()
const study = store.study
const title = 'Datenherkunft'

const datenQuellenOptions = [
  'diz',
  'ibdf',
  'befragung',
  'vonExtern',
  'studie',
  'sonstiges',
  'eigeneRecherche',
]
const datenQuelleExternOptions = ['krankenkasse', 'sonstige']
const eigeneRechercheDokumenteOptions = [
  'arztbriefe',
  'fieberkurve',
  'opBerichte',
  'radiologieBefunde',
  'sonstige',
]
const idatOptions = ['pid', 'fallnummer', 'klarname', 'geburtsdatum', 'adresse']
const quellSystemeOptions = [
  'biobankCentraxx',
  'orbis',
  'metavision',
  'enaio',
  'papierakten',
  'ris',
  'pacs',
  'gedowin',
  'sonstige',
]
const externeDatenOptions = ['pseudonym', 'anonym', 'identifizierbar']
const geraeteOptions = [
  'ct',
  'mrt',
  'meg',
  'eeg',
  'mobilgeraete',
  'eyetracker',
  'roentgen',
  'nichtPortablerRechner',
  'kamera',
  'sonstiges',
]
const mobilgeraeteOptions = ['studienPersonal', 'privat', 'partner', 'umfgu']

const save = () => {
  store.updateChapter('datenherkunft', study.datenherkunft)
}

const showEigeneRecherche = computed(() =>
  study.datenherkunft.datenQuellen.includes('eigeneRecherche'),
)

const showVerwendeteGeraete = computed(() =>
  study.studienparameter.studientypContainer.studientyp.includes('prospektiv'),
)

const showDatenWeitererKliniken = computed({
  get: () => study.datenherkunft.datenWeitererKliniken !== undefined,
  set: (value: boolean) => {
    if (value) {
      study.datenherkunft.datenWeitererKliniken = ''
    } else {
      study.datenherkunft.datenWeitererKliniken = undefined
      study.datenherkunft.einwilligungenWerdenEingeholt = false
    }
    save()
  },
})

const showExterneDaten = computed({
  get: () => study.datenherkunft.verwendungszweckVerknuepfungExtern !== undefined,
  set: (value: boolean) => {
    study.datenherkunft.verwendungszweckVerknuepfungExtern = value ? '' : undefined
    save()
  },
})

function onDatenQuellenChange() {
  if (!(study.datenherkunft.datenQuellen || []).includes('vonExtern')) {
    study.datenherkunft.datenQuelleExtern = []
    study.datenherkunft.datenQuelleExternSonstiges = undefined
  }
  if (!(study.datenherkunft.datenQuellen || []).includes('sonstiges')) {
    study.datenherkunft.datenQuelleSonstiges = undefined
  }
  if (!(study.datenherkunft.datenQuellen || []).includes('eigeneRecherche')) {
    study.datenherkunft.datenQuelleEigeneRechercheDokumenteSonstige = undefined
    study.datenherkunft.datenQuelleEigeneRechercheDokumente = []
    study.datenherkunft.datenQuelleEigeneRechercheIdatBenoetigt = []
  }
  save()
}

function onDatenQuelleExternChange() {
  if (!(study.datenherkunft.datenQuelleExtern || []).includes('sonstige')) {
    study.datenherkunft.datenQuelleExternSonstiges = undefined
  }
  save()
}

function onDatenQuelleEigeneRechercheDokumenteChange() {
  if (!(study.datenherkunft.datenQuelleEigeneRechercheDokumente || []).includes('sonstige')) {
    study.datenherkunft.datenQuelleEigeneRechercheDokumenteSonstige = undefined
  }
  save()
}

function onQuellsystemeChange() {
  if (!(study.datenherkunft.quellSysteme || []).includes('sonstige')) {
    study.datenherkunft.quellSystemeSonstige = undefined
  }
  save()
}

function onVerwendeteGeraeteChange() {
  if (!(study.datenherkunft.verwendeteGeraete.geraete || []).includes('sonstiges')) {
    study.datenherkunft.verwendeteGeraete.verwendeteGeraeteSonstiges = undefined
  }
  save()
}
</script>

<style scoped></style>
